<div class="tfbank-calculator">
  <div
    class="form-group tfbank-calculator__column required"
    [ngClass]="{ 'has-error': loan_period.touched && loan_period.invalid }"
  >
    <label for translate> Select a period </label>
    <select
      aria-placeholder="Period"
      class="custom-select"
      [(ngModel)]="leasePeriod"
      id="region_id"
      (ngModelChange)="calculateLease()"
      name="loan_period"
      #loan_period="ngModel"
      placeholder="test"
      required
      title="Loan period of TFBank"
    >
      @for (period of leasePeriods; track period) {
        <option [ngValue]="period">
          {{ period }}
        </option>
      }
    </select>
  </div>
  <div class="tfbank-calculator__column">
    <label for translate> Your monthly payment </label>
    <div class="month-amount">
      {{ monthlyPayment | number: '1.2-2' }}
      <app-currency></app-currency>
      /
      <span class="month-amount__text" translate> month </span>
      @if (loadingPayment) {
        <mat-progress-spinner></mat-progress-spinner>
      }
    </div>
  </div>
</div>
